import { DeviceFrom1C } from "../responses/device-from-1c";

export class SetCellBySnFrom1CQuery {
    httpQueryId: string;
    devices: DeviceFrom1C[] = [];
}